<div class="field-group">
    <div>
        <mat-form-field class="field-medium">
            <mat-label>Début du traitement</mat-label>
            <input matInput [value]="treatment?.startDate" (dateChange)="treatment.startDate = $event.value" [matDatepicker]="pickerStart">
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Fin du traitement</mat-label>
            <input matInput [value]="treatment?.endDate" (dateChange)="treatment.endDate = $event.value" [matDatepicker]="pickerEnd">
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Nombre de séances</mat-label>
            <input matInput type="number" [value]="treatment?.sessionCount" (change)="treatment.sessionCount = $event.target.value">
        </mat-form-field>
    </div>  
</div>
<div class="field-group">
    <div>
        <mat-form-field class="field-medium">
            <mat-label>Séances prestées</mat-label>
            <input matInput type="number" [value]="treatment?.sessionDone" (change)="increaseSession($event)">
        </mat-form-field>
    </div>  
</div>
<div class="field-line">
    <div>
        <mat-form-field class="field-medium">
            <mat-label>Date de l'accord</mat-label>
            <input matInput [value]="treatment?.agreementDate" (dateChange)="treatment.agreementDate = $event.value" [matDatepicker]="pickerAgreement">
            <mat-datepicker-toggle matSuffix [for]="pickerAgreement"></mat-datepicker-toggle>
            <mat-datepicker #pickerAgreement></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Début de l'accord</mat-label>
            <input matInput [value]="treatment?.agreementStartDate" (dateChange)="treatment.agreementStartDate = $event.value" [matDatepicker]="pickerAgreementStart">
            <mat-datepicker-toggle matSuffix [for]="pickerAgreementStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerAgreementStart></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Fin de l'accord</mat-label>
            <input matInput [value]="treatment?.agreementEndDate" (dateChange)="treatment.agreementEndDate = $event.value" [matDatepicker]="pickerAgreementEnd">
            <mat-datepicker-toggle matSuffix [for]="pickerAgreementEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerAgreementEnd></mat-datepicker>
        </mat-form-field>
    </div>  
</div>
<div class="field-line">
    <div>
        <mat-form-field class="field-medium">
            <mat-label>Date prescription bilan</mat-label>
            <input matInput [value]="treatment?.prescribedDate" (dateChange)="treatment.prescribedDate = $event.value" [matDatepicker]="pickerPrescribed">
            <mat-datepicker-toggle matSuffix [for]="pickerPrescribed"></mat-datepicker-toggle>
            <mat-datepicker #pickerPrescribed></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Prescripteur</mat-label>
            <input matInput type="text" [value]="treatment?.prescriber" (change)="treatment.prescriber = $event.target.value">
        </mat-form-field>
        <mat-form-field class="field-medium">
            <mat-label>Début du bilan</mat-label>
            <input matInput [value]="treatment?.appraisalDate" (dateChange)="treatment.appraisalDate = $event.value" [matDatepicker]="pickerAppraisalDate">
            <mat-datepicker-toggle matSuffix [for]="pickerAppraisalDate"></mat-datepicker-toggle>
            <mat-datepicker #pickerAppraisalDate></mat-datepicker>
        </mat-form-field>
    </div>  
</div>
<div class="field-line">
    <mat-form-field class="field-full-width">
        <mat-label>Description</mat-label>
        <input matInput type="text" [value]="treatment?.description" (change)="treatment.description = $event.target.value">
    </mat-form-field>
</div>  
